import './MobileHeader.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

import { useAppStaticContext } from './AppContext';
import { Button } from './Button';
import { Container } from './Container';
import { Icon } from './Icon';
import { Logo } from './Logo';
import { useMobileNavigationOffcanvas } from './MobileNavigationOffcanvas';

export interface MobileHeaderProps {
  innerRef: React.RefObject<HTMLDivElement>;
  recalculateHeaderHeight(): void;
  visibleUntil: b2x.Breakpoint;
}

export const MobileHeader = ({ innerRef, recalculateHeaderHeight, visibleUntil }: MobileHeaderProps) => {
  const { session } = b2x.useAppContext();
  const { getPagePath } = b2x.useAppStaticContext();

  const [MobileNavigationOffcanvas, showMobileNavigationOffcanvas] = useMobileNavigationOffcanvas();

  const { showAccountOffcanvas, showCartOffcanvas } = useAppStaticContext();

  return (
    <>
      {MobileNavigationOffcanvas}
      <b2x.Sticky className={classnames(`mobile-header d-${visibleUntil}-none bg-black shadow-sm`)} offset={-1}>
        {({ isSticky }) => (
          <b2x.Div innerRef={innerRef} paddingY={2}>
            <Container className="g-0">
              <b2x.Row className="px-2" gap={0}>
                <b2x.Col className="d-flex justify-content-start align-items-center">
                  <div className="hstack gap-1">
                    <Button
                      className="p-2 text-white"
                      iconEnd={{ name: 'menu', size: 22 }}
                      onClick={showMobileNavigationOffcanvas}
                      variant="blank"
                    />
                  </div>
                </b2x.Col>
                <b2x.Col alignItems={'center'} display="flex" size={'auto'}>
                  <Logo recalculateHeaderHeight={recalculateHeaderHeight} type="mobile" />
                </b2x.Col>
                <b2x.Col className="d-flex justify-content-end align-items-center">
                  <div className="hstack gap-1">
                    {session?.customer ? (
                      <b2x.router.Link className="p-2 text-white" to={getPagePath('SITE_ACCOUNT')}>
                        <Icon name="account-logged-in" size={22} />
                      </b2x.router.Link>
                    ) : (
                      <Button
                        className="p-2 text-white"
                        iconEnd={{ name: 'account', size: 22 }}
                        onClick={showAccountOffcanvas}
                        variant="blank"
                      />
                    )}
                    <Button className="position-relative p-2 text-white" onClick={showCartOffcanvas} variant="blank">
                      <Icon name={'cart'} size={22} />
                      {session?.cart?.itemsNumber !== undefined && session.cart.itemsNumber > 0 && (
                        <span className="position-absolute top-0 start-100 rounded-pill translate-middle badge bg-primary">
                          {session.cart.itemsNumber}
                        </span>
                      )}
                    </Button>
                  </div>
                </b2x.Col>
              </b2x.Row>
            </Container>
          </b2x.Div>
        )}
      </b2x.Sticky>
    </>
  );
};
